var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckInSurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7365_4308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7365_4308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83352 17.3208V16L8.18826 17.3208H6.83352ZM17.5844 7.98084L9.39609 15.97L8.04134 14.6475L16.2296 6.66L17.5844 7.98084ZM20 8.00749L16.2296 4.32999L5.12514 15.1633V18.8408H8.89553L20 8.00749ZM14.3504 16.5H12.6386V20.3333H1.70838V3.66667H12.8128V5H14.5212V2H0V22H14.3504V16.5ZM3.41676 7.00033H10.2503V5.33367H3.41676V7.00033ZM3.41676 10.3337H7.68771V8.667H3.41676V10.3337ZM3.41676 13.667H5.12514V12.0003H3.41676V13.667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7365_4308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    width: 24,
    height: 24,
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7365_4308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInSurveys);
export default __webpack_public_path__ + "static/media/CheckInSurveys.c8d42fd7c1085f51263a4ca2e22b5f5c.svg";
export { ForwardRef as ReactComponent };